var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"highlight-bar"},[_c('div',{staticClass:"highlight-bar__container"},[_c('high-light')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }